// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__fLBYd","CreditsLink":"styles_CreditsLink__XDGCQ"};